import React from 'react';
import { withFormsy } from 'formsy-react';
import _ from 'lodash';
import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';

export class SelectInput extends React.Component {
  constructor(props) {
    super(props);

    this.changeValue = this.changeValue.bind(this);
  }

  changeValue(event) {
    const { onChange, setValue } = this.props;
    if (onChange) onChange(event);
    setValue(event.target.value);
  }

  render() {
    const { name, label, required, options, disabled, hint, placeholder, value, errorMessage, isPristine } = this.props;
    const isError = !isPristine && errorMessage != null;

    return (
      <div className="input-container">
        <FormControl error={isError} required={required} disabled={disabled} fullWidth>
          <InputLabel id={`select${name}`} style={{textWrap: 'auto'}}>{label}</InputLabel>
          <Select
            id={name}
            labelId={`select${name}`}
            name={name}
            label={label}
            onChange={this.changeValue}
            value={value || ''}
            SelectDisplayProps={{
              'aria-labelledby': `select${name}`
            }}
            inputProps={{
              'aria-describedby': isError ? `${name}_error` : undefined
            }}
          >
            {options.map((option, i) => (
              _.isString(option) ?
                <MenuItem key={i} value={option}>{option}</MenuItem>
              :
                <MenuItem key={i} value={option.value}>{option.label}</MenuItem>
            ))}
          </Select>

          {!isPristine && errorMessage &&
            <span aria-live="polite">
              <FormHelperText id={`${name}_error`}>{errorMessage}</FormHelperText>
            </span>
          }
          {hint &&
            <FormHelperText style={{marginBottom: 10}}>{hint}</FormHelperText>
          }
        </FormControl>
      </div>
    );
  }
}

export default withFormsy(SelectInput);
